/**
 * Seeroo's real contact details, in one place.
 *
 * They were typed out separately in the footer, the contact page and the
 * privacy policy, which is how the site ended up publishing a Thrissur office
 * and a hello@aghosha.test address nobody reads. The privacy page is the one
 * that makes it matter — it names this address as where a grievance or a
 * deletion request goes — so every surface now reads from here.
 */

/** The company behind Aghosha: the "we" the privacy policy refers to. */
export const OPERATOR = 'Seeroo IT Solutions';

export const POSTAL_ADDRESS =
  'XIII/330, Santhigiri Campus, NAD Road, North Kalamassery, HMT Kalamassery, Kochi, Kerala 683503, India';

/** Shown as written; `PHONE_HREF` is the same number dialled. */
export const CONTACT_PHONE = '+91 96566 51087';
export const PHONE_HREF = `tel:${CONTACT_PHONE.replace(/\s/g, '')}`;

export const CONTACT_EMAIL = 'info@seeroo.com';
export const EMAIL_HREF = `mailto:${CONTACT_EMAIL}`;

/** Drops a map pin on the office rather than on the city. */
export const MAP_QUERY = encodeURIComponent(`${OPERATOR}, ${POSTAL_ADDRESS}`);
